import { z } from "zod";
import { InductionProps } from "../../InductionFeedbackForm";

export const inductionSchema = z.object({
  name: z.string().min(1, "Name is required."),
  priorEmployer: z.string().min(1, "Prior employer is required."),
  dateOfJoining: z.string().min(1, "Date of joining is required."),
  departmentName: z.string().min(1, "This field is required."),

  inductionRatingOverall: z.string().min(1, "Please select an option."),
  inductionHelpedUnderstandJob: z.string().min(1, "Please select an option."),
  introducedToColleagues: z.string().min(1, "Please select an option."),
  inductionHelpedMakeFriends: z.string().min(1, "Please select an option."),
  topicsRelevantToWork: z.string().min(1, "Please select an option."),
  managerMetOnFirstDay: z.string().min(1, "Please select an option."),
  warmWelcomeByColleagues: z.string().min(1, "Please select an option."),
  knowWhoToApproach: z.string().min(1, "Please select an option."),
  jobResponsibilitiesExplained: z.string().min(1, "Please select an option."),
  checklistUseful: z.string().min(1, "Please select an option."),
  receivedOfficeTour: z.string().min(1, "Please select an option."),
  policiesExplained: z.string().min(1, "Please select an option."),
  payrollPoliciesCovered: z.string().min(1, "Please select an option."),
  receivedLiteratureCopy: z.string().min(1, "Please select an option."),
  paperworkAvailable: z.string().min(1, "Please select an option."),

  signatureDate: z.string().min(1, "Date is required."),
  signature: z.instanceof(File, {
    message: "Signature is required",
  }),
});

export const validateInductionForm = (formData: InductionProps) => {
  const result = inductionSchema.safeParse(formData);

  if (result.success) {
    return {
      errors: {},
      firstError: null,
      data: result.data,
    };
  }

  const errors: Partial<Record<keyof InductionProps, string>> = {};

  result.error.issues.forEach((issue) => {
    const key = issue.path[0] as keyof InductionProps;
    // console.log("issuye", issue);

    if (!errors[key]) {
      errors[key] = issue.message;
    }
  });

  const firstError = result.error.issues[0]?.message ?? null;

  return {
    errors,
    firstError,
    data: null,
  };
};

// import { FormDataInduction } from "../../InductionFeedbackForm";
// import {
//   required,
//   requiredSelect,
//   validateForm,
//   FormErrors,
//   ValidationSchema,
// } from "../validation-engine/ValidationEngine";

// // ─── FormErrors is now just this one line ─────────────────────────────────────
// export type InductionFormErrors = FormErrors<FormDataInduction>;

// // ─── Schema ───────────────────────────────────────────────────────────────────
// export const inductionSchema: ValidationSchema<FormDataInduction> = {
//   name: [required("Name is required.")],
//   priorEmployee: [required()],
//   dateOfJoining: [required("Date of joining is required.")],
//   departmentName: [required()],

//   inductionRatingOverall: [requiredSelect()],
//   inductionHelpedUnderstandJob: [requiredSelect()],
//   introducedToColleagues: [requiredSelect()],
//   inductionHelpedMakeFriends: [requiredSelect()],
//   topicsRelevantToWork: [requiredSelect()],
//   managerMetOnFirstDay: [requiredSelect()],
//   warmWelcomeByColleagues: [requiredSelect()],
//   knowWhoToApproach: [requiredSelect()],
//   jobResponsibilitiesExplained: [requiredSelect()],
//   checklistUseful: [requiredSelect()],
//   receivedOfficeTour: [requiredSelect()],
//   policiesExplained: [requiredSelect()],
//   payrollPoliciesCovered: [requiredSelect()],
//   receivedLiteratureCopy: [requiredSelect()],
//   paperworkAvailable: [requiredSelect()],
//   signatureDate: [required("Date is required")],
// };

// export const validateInductionForm = (
//   formData: FormDataInduction,
// ): InductionFormErrors => validateForm(formData, inductionSchema);
